<div class="wrapper logo-big show-gt-mobile" fxLayout="Column">
  <div class="logo">
    <img src="../../../../assets/ldw-logo.png" title="LiveDOK-Web" />
  </div>
  <div class="version-label">{{ longVersion }}</div>
</div>

<div class="wrapper show-lt-mobile">
  <div class="logo">
    <img src="../../../../assets/ldw-logo-small.png" title="LiveDOK-Web" />
  </div>
  <div class="version-label">{{ shortVersion }}</div>
</div>
